import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Heading5 } from '../../../components/Typography';

import { useFertilityIframe } from './useFertilityIframe.hook';

import './index.scss';

const IFRAME_CONFIG_IDS = {
  fertilityConsultation: '84655239',
  stdConsultation: '84654621'
};

const FertilityIframe = memo(
  ({
    data,
    dataLoading,
    language,
    dispatch,
    conversationFlowStateKey,
    conversationId,
    userData,
    testCode
  }) => {
    const { info } = data;
    const { userId } = userData || {};

    const {
      containerRef,
      iframeLoading,
      scriptError,
      IFRAME_WRAPPER_ID
    } = useFertilityIframe({
      configId: IFRAME_CONFIG_IDS[info.type],
      language,
      testCode,
      conversationFlowStateKey,
      conversationId,
      userId,
      dispatch
    });

    return (
      <div className='fertility-iframe'>
        <div
          className={cx('fertility-iframe__container', {
            'fertility-iframe__container--loading-iframe': iframeLoading
          })}
        >
          <div id={IFRAME_WRAPPER_ID} ref={containerRef}></div>

          {(dataLoading || iframeLoading) && (
            <div className='fertility-iframe__loading-overlay'>
              <div className='fertility-iframe__loader'></div>
            </div>
          )}

          {scriptError && (
            <Heading5 className='fertility-iframe__error-message'>
              <FormattedMessage
                id='test-result.try-again-later'
                defaultMessage='Something went wrong. Please try again later.'
              />
            </Heading5>
          )}
        </div>
      </div>
    );
  }
);

FertilityIframe.propTypes = {
  dispatch: PropTypes.func,
  conversationFlowStateKey: PropTypes.string,
  conversationId: PropTypes.string,
  userData: PropTypes.object,
  dataLoading: PropTypes.bool,
  data: PropTypes.shape({
    info: PropTypes.shape({
      type: PropTypes.string
    })
  }),
  language: PropTypes.string,
  testCode: PropTypes.string
};

export default FertilityIframe;
